// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const NorthWestOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_123_5854)"},"children":[{"tag":"path","attrs":{"d":"M5 15h2V8.41L18.59 20 20 18.59 8.41 7H15V5H5v10z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_123_5854"},"children":[{"tag":"path","attrs":{"d":"M0 0h24v24H0z","fill":"#fff"}}]}]}]},"name":"north_west","theme":"outlined"};

const NorthWestOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={NorthWestOutlinedSvg} />;
  NorthWestOutlined.displayName = 'NorthWestOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(NorthWestOutlined);
